// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xbcV","toggle":"styles_toggle__2mf_E","preview":"styles_preview__gzx2Z"};